var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_1493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 36C16.5 24.7643 16.5 19.1465 19.1965 15.1109C20.3638 13.3638 21.8638 11.8638 23.6109 10.6965C27.6465 8 33.2643 8 44.5 8C55.7357 8 61.3535 8 65.3891 10.6965C67.1362 11.8638 68.6362 13.3638 69.8035 15.1109C72.5 19.1465 72.5 24.7643 72.5 36C72.5 47.2357 72.5 52.8535 69.8035 56.8891C68.6362 58.6362 67.1362 60.1362 65.3891 61.3035C61.3535 64 55.7357 64 44.5 64C33.2643 64 27.6465 64 23.6109 61.3035C21.8638 60.1362 20.3638 58.6362 19.1965 56.8891C16.5 52.8535 16.5 47.2357 16.5 36Z",
    fill: "url(#paint0_linear_86_1493)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4989 20C40.0323 20 36.4003 23.4073 36.4003 27.5975C36.4003 31.7112 39.8242 35.042 44.2973 35.1769C44.426 35.1668 44.5655 35.1648 44.6792 35.1769C44.707 35.1789 44.7349 35.1809 44.7628 35.1809H44.7907C49.1522 35.044 52.5826 31.7152 52.5998 27.5995C52.5998 23.4093 48.9677 20.002 44.5011 20.002L44.4989 20Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1597 39.4456C48.4013 36.465 40.633 36.4609 35.8403 39.4456C35.8403 39.4456 35.8403 39.4456 35.8382 39.4456C33.6821 40.8001 32.4957 42.6335 32.5 44.6119C32.5022 46.5842 33.6885 48.4096 35.8403 49.752C38.2281 51.2514 41.3646 52.0001 44.5011 52.0001C47.6376 52.0001 50.7741 51.2514 53.1618 49.752C55.3179 48.3975 56.5043 46.5621 56.5 44.5857C56.4978 42.6134 55.3115 40.788 53.1597 39.4456Z",
    fill: "#D3A837"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_1493",
    x: 0.5,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.827451 0 0 0 0 0.658824 0 0 0 0 0.215686 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_1493"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_1493",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_1493",
    x1: 44.5,
    y1: 8,
    x2: 44.5,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE0B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE88"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.cf3022843e8c937bf042f8a45cfc2f9a.svg";
export { ForwardRef as ReactComponent };